import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "nav" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("b", { style: {"font-size":"24px"} }, "地域共同配送システムポケットストア", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isLogin)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/",
            style: {"float":"left","margin-right":"20px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("配送システム")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isLogin)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: "/commodity",
            style: {"float":"left"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("管理システム")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _hoisted_2,
      (!_ctx.isLogin)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            to: "/login",
            style: {"float":"right"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("ログイン")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isLogin)
        ? (_openBlock(), _createElementBlock("a", {
            key: 3,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.LogOutView && _ctx.LogOutView(...args))),
            style: {"float":"right"}
          }, "ログアウト"))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_router_view),
    _createVNode(_component_a_modal, {
      open: _ctx.visible,
      "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
      onOk: _ctx.LogOut
    }, {
      default: _withCtx(() => [
        _createTextVNode(" ログアウトしますか？ ")
      ]),
      _: 1
    }, 8, ["open", "onOk"])
  ], 64))
}